import React from 'react';
import { ToastProps } from '../../types/toast-types';
import { useToast } from '../../hooks/useToast';

const Toast: React.FC<ToastProps> = ({
  message,
  type = 'info',
  duration = 3000,
  position = 'top-right',
  onClose,
  closable = true,
  icon,
  action,
  style = {},
  className = ''
}) => {
  const {
    isVisible,
    handleClose,
    toastStyle,
    iconDefault
  } = useToast({ duration, onClose, position, type, style });

  if (!isVisible) return null;

  return (
    <>
      <style>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-20px) ${position.includes('center') ? 'translateX(-50%)' : ''};
          }
          to {
            opacity: 1;
            transform: translateY(0) ${position.includes('center') ? 'translateX(-50%)' : ''};
          }
        }
        @keyframes slideOut {
          from {
            opacity: 1;
            transform: translateY(0) ${position.includes('center') ? 'translateX(-50%)' : ''};
          }
          to {
            opacity: 0;
            transform: translateY(-20px) ${position.includes('center') ? 'translateX(-50%)' : ''};
          }
        }
      `}</style>
      <div style={toastStyle} className={className}>
        <span style={{ fontSize: '18px', flexShrink: 0 }}>
          {icon || iconDefault}
        </span>
        <span style={{ flex: 1, fontSize: '14px', fontWeight: '500' }}>
          {message}
        </span>
        {action && (
          <button
            onClick={action.onClick}
            style={{
              background: 'none',
              border: 'none',
              color: 'inherit',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              textDecoration: 'underline',
              padding: '0'
            }}
          >
            {action.label}
          </button>
        )}
        {closable && (
          <button
            onClick={handleClose}
            style={{
              background: 'none',
              border: 'none',
              color: 'inherit',
              fontSize: '20px',
              cursor: 'pointer',
              padding: '0',
              lineHeight: '1',
              marginLeft: '8px'
            }}
          >
            ×
          </button>
        )}
      </div>
    </>
  );
};

export default Toast;

